import React from 'react';
import { Col } from 'antd';
import DataTable from 'react-data-table-component';
import PdButton from 'components/pd-button';

export function TableList(props) {
  const {
    changePage = {},
    columns,
    loadingOrder,
    nextPage = -1,
    orderList,
    page = 1,
    responsive = true,
  } = props;

  return (
    <>
      <Col xs={24}>
        <DataTable
          columns={columns}
          data={orderList}
          highlightOnHover
          noHeader
          progressPending={loadingOrder}
          responsive={responsive}
          striped
        />
      </Col>
      <Col span={8} offset={8}>
        <div className="center-button">
          {+page !== 1 && (
            <PdButton
              type="primary"
              outline
              style={{ height: 32 }}
              onClick={() => changePage(Number(page) - 1)}>
              Previous
            </PdButton>
          )}
          {+nextPage !== -1 && (
            <PdButton
              type="primary"
              outline
              style={{ height: 32 }}
              onClick={() => changePage(Number(page) + 1)}>
              Next
            </PdButton>
          )}
        </div>
      </Col>
    </>
  );
}

export default { TableList };
